<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
    right
  >
    <template
      v-slot:activator
    >
      <v-chip          
        class="ma-1"
        close
        @click:close="menu = true"
      >
        <v-avatar
          tile
          left
        >
          <img :src="skill.image_url">
        </v-avatar>
        {{ skill.name }}
      </v-chip>
    </template>
    <v-card>
      <v-card-text> Are you sure you want to remove this skill? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        > 
          No 
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      jobDescriptionId: {
        type: Number,
        required: true,
      },
      skill: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.jobRequirements().delete(this.jobDescriptionId, this.skill.id)
          .then(response => {
            if (response.status === 200) {
              this.$emit('deleted')
              this.$snack({ message: response.data.status })

              this.menu = false
            }
          })
          .catch(error => {
            if (error.response.status === 405) {
              this.$snack({ 
                color: 'error',
                message: error.response.data.status, 
              })      
            }
          })
          .then(() => {          
            this.progressing = false
          })    
      },
    },
  }
</script>
